module.exports = __webpack_public_path__ + "f38704b29a4adf4fb7070cba138821ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio1/mutaflor_holder.jpg
// module id = 893
// module chunks = 0